import { HiTrash, HiX } from "react-icons/hi";
import { useTranslation } from "@repo/core";

const ConfirmationModal = ({
  isDeleting,
  handleRemoveConfirm,
  handleRemoveCancel,
  modelId,
}: {
  isDeleting: boolean;
  handleRemoveConfirm: () => void;
  handleRemoveCancel: () => void;
  modelId?: string;
}) => {
  const isDraft = modelId?.includes('_draft');
  const { tStrategy } = useTranslation();

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          handleRemoveCancel();
        }
      }}
    >
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <h3 className="text-lg font-medium text-gray-900 mb-4">
          {tStrategy("removeModal.title")}
        </h3>
        <div className="text-gray-600 mb-6">
          <p>
            {isDraft
              ? tStrategy("removeModal.confirmDraft")
              : tStrategy("removeModal.confirmStrategy")}
          </p>
          {isDraft ? (
            <p className="mt-2 text-sm text-amber-600">
              {tStrategy("removeModal.draftNote")}
            </p>
          ) : (
            // Drafts are never traded, so the broker/monitoring caveat only
            // applies to a live portfolio.
            <p className="mt-4">{tStrategy("removeModal.tradingWarning")}</p>
          )}
        </div>
        <div className="flex gap-3 justify-end">
          <button
            onClick={handleRemoveConfirm}
            disabled={isDeleting}
            className="cursor-pointer flex items-center gap-2 px-4 py-2 bg-red-600 text-white hover:bg-red-700 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <HiTrash size={16} />
            {isDeleting ? tStrategy("removeModal.removing") : tStrategy("removeModal.confirm")}
          </button>
          <button
            onClick={handleRemoveCancel}
            disabled={isDeleting}
            className="cursor-pointer flex items-center gap-2 px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <HiX size={16} />
            {tStrategy("removeModal.cancel")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
